/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { Tooltip } from "@mui/material";
import React from "react";

function FriendToMember({ width = 23.467, height = 24, ...props }) {
  return (
    <Tooltip title="Change to Member" placement="top">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 32 30"
        x="0px"
        y="0px"
        preserveAspectRatio="xMidYMid meet"
        {...props}
      >
        <g data-name="Layer 8">
          <path d="M18,15A10.0111,10.0111,0,0,0,8,25v2a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V25A10.0111,10.0111,0,0,0,18,15Z" />
          <circle cx="18" cy="9" r="5" />
          <path d="M8.293,9.293a1,1,0,1,0,1.414,1.414l2-2a.9994.9994,0,0,0,0-1.414l-2-2A1,1,0,0,0,8.293,6.707L8.5859,7H6A1,1,0,0,0,6,9H8.5859Z" />
        </g>
      </svg>
    </Tooltip>
  );
}

export default FriendToMember;
